/****
 * 报表相关接口
 */
import axios from 'axios';

// 未结明细
export const unsettle = () => {
  return axios.get('/ssc_golang/v1/report/unsettle');
};

// 未结明细详情
export const unsettle2 = lottery_type => {
  return axios.get('/ssc_golang/v1/report/unsettle2', {params: {lottery_type}});
};


// 历史报表
export const history = () => {
  return axios.get('/ssc_golang/v1/report/history');
};

// 今日已结
export const history2 = (date = '') => {
  return axios.get('/ssc_golang/v1/report/history2', {params: {date}});
};


export const history3 = ({date, lottery_type}) => {
  return axios.get('/ssc_golang/v1/report/history3', {params: {date, lottery_type}});
};

export const history4 = ({period,lottery_type}) => {
  return axios.get('/ssc_golang/v1/report/history4', {params: {period, lottery_type}});
};



// WEBPACK FOOTER //
// ./src/service/report.js